<template>
  <ModalFormulario
    :model-value="modelValue"
    :titulo="titulo"
    tamanho="sm"
    @update:model-value="fechar"
    @confirmar="salvar"
  >
    <template #footer>
      <button type="button" class="btn btn-secondary" @click="fechar">
        Cancelar
      </button>
      <button type="button" class="btn btn-outline-primary" @click="salvar">
        <i class="bi bi-check-lg me-1"></i>Salvar
      </button>
      <button type="button" class="btn btn-primary" @click="executar">
        <i class="bi bi-play-fill me-1"></i>Executar
      </button>
    </template>

    <div v-if="seed" class="d-flex flex-column gap-3">
      <p class="text-body-secondary small mb-0">{{ seed.descricao }}</p>

      <template v-for="campo in campos" :key="campo.chave">
        <!-- Lista de opções (ex: Fase A/B/C) -->
        <CampoSelect
          v-if="campo.tipo === 'select'"
          :id="campo.chave"
          :label="campo.label"
          v-model="valores[campo.chave]"
          :options="campo.opcoes || []"
          option-value="id"
          option-label="label"
          :dica="campo.dica"
        />

        <!-- Data (ex: vigência) -->
        <CampoInput
          v-else-if="campo.tipo === 'data'"
          :id="campo.chave"
          :label="campo.label"
          type="date"
          v-model="valores[campo.chave]"
          :descricao-informativa="campo.dica"
        />

        <!-- Booleano (Sim/Não) — padrão -->
        <CampoSelect
          v-else
          :id="campo.chave"
          :label="campo.label"
          v-model="valores[campo.chave]"
          :options="simNaoOptions"
          option-value="id"
          option-label="label"
          :dica="campo.dica"
        />
      </template>
    </div>
  </ModalFormulario>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import ModalFormulario from '@/components/base/modal/ModalFormulario.vue'
import CampoSelect from '@/components/base/campos/CampoSelect.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  seed: { type: Object, default: null },
  config: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['update:modelValue', 'salvar', 'executar'])

const simNaoOptions = [
  { id: true, label: 'Sim' },
  { id: false, label: 'Não' }
]

const valores = ref({})

const campos = computed(() => props.seed?.camposConfig || [])

const titulo = computed(() => props.seed ? `Configurações — ${props.seed.nome}` : 'Configurações')

watch(() => props.modelValue, (aberto) => {
  if (aberto) {
    const base = {}
    for (const campo of campos.value) {
      base[campo.chave] = props.config?.[campo.chave] ?? campo.padrao
    }
    valores.value = base
  }
})

function fechar () {
  emit('update:modelValue', false)
}

function salvar () {
  emit('salvar', { seed: props.seed, valores: { ...valores.value } })
  fechar()
}

function executar () {
  emit('executar', { seed: props.seed, valores: { ...valores.value } })
  fechar()
}
</script>
